import { render, staticRenderFns } from "./AdminUserView.vue?vue&type=template&id=3bbbefa8&"
import script from "./AdminUserView.vue?vue&type=script&lang=ts&"
export * from "./AdminUserView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports